<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="blog">
    <NavBar />
    <div class="container">
      <h1 class="text-left mt-5 mb-3">Le blog de l'équipe</h1>

      <div class="row mt-5">
        <div class="col-12 col-md-4 order-md-2 mt-3 mb-5">
          <div class="card text-left mb-3">
            <div class="card-body">
              <NewsletterForm />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Nous suivre sur les réseaux sociaux :</h5>
              <ReseauxSociaux />
            </div>
          </div>
        </div>

        <div class="col-12 my-3 col-md-8">
          <p class="h4 text-left derniers-articles">Les derniers articles :</p>

          <div class="card mb-3" v-for="article in orderedArticles" :key="article.id">
            <div class="card-body article">
              <img class="card-img-top" :src="article.main_image" :alt="article.main_image_alt_text" />
              <div class="text">
                <p class="card-subtitle text-left mt-2">
                  {{ new Date(article.datetime_published).toLocaleString("fr-FR", date_options) }}
                </p>
                <p class="card-title">{{ article.title }}</p>
                <p class="card-text text-left">{{ truncate(article.content) }}...</p>
                <router-link
                  :to="{ name: 'BlogShow', params: { id: article.id, slug: article.slug } }"
                  class="text-right next"
                >
                  Lire l'article &#62;
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "@/components/NavBar.vue";
import NewsletterForm from "@/components/NewsletterForm.vue";
import ApiService from "@/services/ApiService";
import ReseauxSociaux from "@/components/ReseauxSociaux.vue";

export default {
  name: "Blog",
  components: {
    NavBar,
    NewsletterForm,
    ReseauxSociaux
  },
  data: () => {
    return {
      articles: [],
      date_options: {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      }
    };
  },
  methods: {
    truncate(str) {
      return str.split(" ").splice(0, 30).join(" ").replace(/#/g, "").replace(/\*/g, "").replace(/_/g, "");
    }
  },
  mounted() {
    ApiService.get("/articles").then((response) => {
      this.articles = response.data.articles;
    });
  },
  computed: {
    orderedArticles: function () {
      return this.articles.slice().sort((a, b) => new Date(b.datetime_published) - new Date(a.datetime_published));
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  background-color: $light;
  border: none;
  border-radius: $card-radius;
  overflow: hidden;
}
.article {
  padding: 0;
}
.derniers-articles {
  position: absolute;
  top: -40px;
}
.text {
  padding: 1.25rem;
}
.text .card-subtitle {
  font-style: italic;
  font-size: 14pt;
}
.text .card-title {
  font-size: 1.5em;
  text-align: left;
  margin-bottom: 0.5em;
  font-weight: bold !important;
}
.next {
  display: inline-block;
  width: 100%;
}
.blog {
  background-color: white;
  min-height: 100vh;
}
.card-img-top {
  background-color: $light;
}
</style>
